import { instanceOfErrorListResponse, ErrorListResponse } from '@genial/services';
import { useEffect, useState } from 'react';

import { useRecoilQuery } from '../../../../../../../hooks/useRecoilQuery';
import { useToastCreator } from '../../../../../../../hooks/useToastCreator';
import { AssetSelectedTypeMap } from '../../../../../../../store/product/types';
import { fundsWithdrawSimulateTax } from '../../../../../../../store/redemptionSolicitation/selector';
import { FundWithdrawTaxSimulateNormalized } from '../../../../../../../store/redemptionSolicitation/types';

export type DateErrorMessage = { message: string };

interface FundsSellTaxSimulationControllerProps {
  valueToSimulate: number;
  product: AssetSelectedTypeMap['fundsSell'];
}

export const useFundsSellTaxSimulationController = ({
  valueToSimulate,
  product,
}: FundsSellTaxSimulationControllerProps) => {
  const { showToastFromError } = useToastCreator('redemption-fund-tax-toast');

  const [taxSimulationResponse, setTaxSimulationResponse] =
    useState<FundWithdrawTaxSimulateNormalized>();

  const { data, loading, error } = useRecoilQuery(
    fundsWithdrawSimulateTax({
      fundId: Number(product.productId),
      portfolioId: product.portfolioId,
      value: valueToSimulate,
    }),
    {
      if: () => valueToSimulate !== product.amountToRedemption,
    }
  );

  useEffect(() => {
    if (error) {
      if (instanceOfErrorListResponse(error)) {
        (error as unknown as ErrorListResponse).errors?.forEach((errorItem) =>
          showToastFromError(errorItem)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    if (valueToSimulate === product.amountToRedemption) {
      setTaxSimulationResponse(undefined);
    }
  }, [valueToSimulate, product.amountToRedemption]);

  useEffect(() => {
    if (!loading && data) {
      setTaxSimulationResponse(data);
      if (!data.isBalanceAvailable) {
        showToastFromError({
          errorTitle: 'Ocorreu um erro!',
          errorMessage: data.taxSimulatorMessage,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, data]);

  return {
    isLoadingTaxes: loading,
    taxSimulationResponse,
  };
};
